import { Broker } from '@axo/shared/data-access/types/broker';
import * as brokerLogos from './logos';
import { ReactNode } from 'react';

const BROKER_LOGO_MAPPING: Record<Broker, string> = {
  [Broker.Axo]: brokerLogos.AxoBroker,
  [Broker.Zmarta]: brokerLogos.ZmartaBroker,
};

interface BrokerLogoProps {
  broker?: Broker;
  fallback?: ReactNode;
  className?: string;
}

export const BrokerLogo: React.FC<BrokerLogoProps> = ({
  broker,
  fallback,
  className,
}) => {
  const logoSrc =
    broker !== undefined ? BROKER_LOGO_MAPPING[broker] : undefined;

  if (!logoSrc && fallback !== undefined) {
    return fallback;
  }

  return (
    <img
      src={logoSrc}
      className={className}
      aria-label={`Broker ${broker ? Broker[broker] : 'unknown'}`}
    />
  );
};
